<template>
  <el-dialog title="音频播放" :visible.sync="dialog" width="680px" :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true">
    <div class="audio-wrap">
      <audio :src="file" ref="audioContainer" controls>
        <span>
          <span>您的浏览器不支持音频文件播放，</span>
          <a :href="file" target="_blank">请点击此处收听</a>
        </span>
      </audio>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      file: '',
      dialog: false,
    };
  },
  methods: {
    readyLoad(url) {
      if (url) {
        this.file = url;
        this.dialog = true;
      }
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.audioContainer.play();
        });
      } else {
        this.$refs.audioContainer.pause();
        this.file = '';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.audio-wrap {
  audio {
    width: 100%;
  }
}
</style>
